import { render, staticRenderFns } from "./NotificationAffiliateRecipient.vue?vue&type=template&id=e470ee34&"
import script from "./NotificationAffiliateRecipient.vue?vue&type=script&lang=ts&"
export * from "./NotificationAffiliateRecipient.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationAffiliateRecipient.vue?vue&type=style&index=0&id=e470ee34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports